createComponent